import { render } from "./LeavesCalender.vue?vue&type=template&id=577b36b2&scoped=true"
import script from "./LeavesCalender.vue?vue&type=script&lang=js"
export * from "./LeavesCalender.vue?vue&type=script&lang=js"

import "./LeavesCalender.vue?vue&type=style&index=0&id=577b36b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577b36b2"]])

export default __exports__